import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface SidebarState {
  expanded: boolean;
  activeItem: string;
  activeSubItem: string;
  isMobile: boolean;
  mobileSidebarOpen: boolean;
  shipmentExpanded: boolean;
  hoveredItem: string | null;
}

const initialState: SidebarState = {
  expanded: false,
  activeItem: "dashboard",
  activeSubItem: "",
  isMobile: false,
  mobileSidebarOpen: false,
  shipmentExpanded: false,
  hoveredItem: null,
};

const sidebarSlice = createSlice({
  name: "sidebar",
  initialState,
  reducers: {
    setExpanded: (state, action: PayloadAction<boolean>) => {
      state.expanded = action.payload;
    },
    setActiveItem: (state, action: PayloadAction<string>) => {
      state.activeItem = action.payload;
    },
    setActiveSubItem: (state, action: PayloadAction<string>) => {
      state.activeSubItem = action.payload;
    },
    setIsMobile: (state, action: PayloadAction<boolean>) => {
      state.isMobile = action.payload;
    },
    setMobileSidebarOpen: (state, action: PayloadAction<boolean>) => {
      state.mobileSidebarOpen = action.payload;
    },
    setShipmentExpanded: (state, action: PayloadAction<boolean>) => {
      state.shipmentExpanded = action.payload;
    },
    setHoveredItem: (state, action: PayloadAction<string | null>) => {
      state.hoveredItem = action.payload;
    },
  },
});

export const {
  setExpanded,
  setActiveItem,
  setActiveSubItem,
  setIsMobile,
  setMobileSidebarOpen,
  setShipmentExpanded,
  setHoveredItem,
} = sidebarSlice.actions;

export default sidebarSlice.reducer;
